import { ACPVariant } from 'apps/acp/variants/acp-variant';

const colors = {
  neutral: {
    color0: '#ffffff',
    color50: '#F7F8F8',
    color100: '#EFF0F0',
    color200: '#E0E1E1',
    color300: '#D0D2D1',
    color400: '#C1C3C2',
    color500: '#97999B',
    color600: '#8E908F',
    color700: '#333F48',
    color800: '#333F48',
    color900: '#232424'
  },
  default: {
    color50: '#F0EBF8',
    color100: '#E0D7F0',
    color200: '#C2AFE2',
    color300: '#A388D3',
    color400: '#8560C5',
    color500: '#6638B6',
    color600: '#522D92',
    color700: '#3D226D',
    color800: '#291649',
    color900: '#140B24'
  },
  accent: {
    color50: '#E5F1F8',
    color100: '#CAE3F0',
    color200: '#94C7E1',
    color300: '#5FABD1',
    color400: '#298FC2',
    color500: '#44D62C',
    color600: '#1B5F81',
    color700: '#154861',
    color800: '#0E3041',
    color900: '#071820'
  },
  positive: {
    color50: '#D1F5CB',
    color100: '#A2EB96',
    color200: '#44D62C',
    color300: '#3CBB27',
    color400: '#33A121',
    color500: '#2B861C',
    color600: '#226B16',
    color700: '#1A5011',
    color800: '#11360B',
    color900: '#091B06'
  },
  negative: {
    color50: '#F9E9EC',
    color100: '#F3D2D8',
    color200: '#E7A5B0',
    color300: '#DC7889',
    color400: '#D04B61',
    color500: '#C41E3A',
    color600: '#9D182E',
    color700: '#761223',
    color800: '#4E0C17',
    color900: '#27060C'
  },
  special: {
    color50: '#D1F5CB',
    color100: '#A2EB96',
    color200: '#44D62C',
    color300: '#3CBB27',
    color400: '#33A121',
    color500: '#2B861C',
    color600: '#226B16',
    color700: '#F0F3F3',
    color800: '#11360B',
    color900: '#091B06'
  }
};

const variant: ACPVariant = {
  id: 'www.yesdebit.com',
  productTitle: 'Yes! Debit Account',
  productType: 'consumer_dda',
  accessDomain: {
    subdomain: 'www',
    domain: 'yesdebit',
    topLevelDomain: 'com'
  },
  colors,
  themeConfiguration: {
    acpActivationAppBar: {
      defaultBackgroundColor: colors.neutral.color0
    },
    acpRisingTideLayout: {
      appBarDefaultBackgroundColor: colors.neutral.color0
    }
  },
  legacyAcpTheme: 'yes-debit',
  legacyLegosTheme: 'generic-theme',
  legacyAcpBrandName: 'yesdebit',
  status_bar_background_color: colors.neutral.color0,
  status_bar_foreground_color: 'dark',
  contactInfo: {
    name: 'Yes! Debit',
    contact_address_line1: 'PO Box 2136',
    contact_address_line2: 'Austin, TX 78768',
    contact_address_line3: '',
    customer_support_email: 'customerservice@yesdebit.com',
    fax_formatted: '(866) 358-0526',
    phone_formatted: '1-833-954-0799',
    phone: '18339540799',
    phone_international: '737-220-8956',
    balance_check_phone: '18339541605',
    balance_check_phone_formatted: '1-833-954-1605',
    pre_funded_checks_phone: '18778147683',
    pre_funded_checks_phone_formatted: '1-877-814-7683'
  },
  configuration: {
    apiKeys: {
      appsFlyerDevKey: '',
      appsFlyerBannerKey: 'c105c25f-a85d-471d-a684-dac49341ad91',
      'google-tag-manager-container-id': 'GTM-NQXKPD',
      'google-tag-manager-container-id-mobile': 'GTM-MWBTT5M',
      paypalFraudNetPayerIdProd: '',
      paypalFraudNetPayerIdTest: ''
    },
    featureToggles: {
      activationSetExternalId: false,
      appsFlyerEnabled: false,
      combinedTransactionsMasterAndSub: false,
      'embedded-activation': true,
      embeddedPayNearMe: false,
      hasNotificationCenter: false,
      mobilePBREnabled: true,
      preOnboardingEnabled: false,
      showAccountDisplayNickname: false,
      showAcquisitionLink: false,
      showATMFriendlyCards: true,
      showDisplayNameForSubAccount: false,
      showEmailInformationButton: true,
      showFeePlanPage: false,
      showHowToEarnRewardPointLink: true,
      showRegisterLink: false,
      showScanCardRegistration: false,
      showMarketingSiteLink: false,
      showFreeAtmFinderLink: false,
      showWUTransfers: false,
      showReloadLocationLink: false
    },
    misc: {
      distributor: 'cfsonlineacq',
      layoutComponentOverride: false,
      layoutAppBarInverted: true,
      loader: 'generic',
      payNearMeButtonTextColor: '#FFFFFF',
      payNearMeActionBarBackgroundColor: colors.default.color500,
      payNearMeTitleTextColor: '#FFFFFF',
      payNearMeColorAccent: colors.accent.color500,
      marketingSiteUrl: 'https://www.yesdebit.com',
      marketingSiteLinkText: 'Yesdebit.com',
      locationSearchMax: '25',
      iOSAppId: '6443558918'
    },
    content: {
      signUpContent: "Don't have a card? Sign up today.",
      copyrightStatement:
        'Netspend Corporation All rights reserved worldwide. Netspend is the federally registered U.S. service mark of Netspend Corporation All other trademarks and service marks belong to their owners.'
    },
    disclaimers: {
      overdraftDisclaimer: `The Debit Card Overdraft Service is an optional service made available to eligible Yes! Debit™ customers by Pathward, N.A. Once you enroll and meet the eligibility requirements, you will be charged $20.00 for each transaction that overdraws your account by more than $10.00, up to a maximum of five (5) fees per calendar month. To avoid that fee, you have twenty-four (24) hours from the time of the first transaction that creates the overdraft to bring your Account back to a zero ($0.00) or a positive balance. Transactions subject to an overdraft fee are signature and PIN purchase transactions and ATM transactions. ACH Debit transactions are not eligible for coverage. Any negative balance must be repaid within thirty (30) days. <b>Whether we authorize an overdraft is discretionary, and we reserve the right not to pay.</b> For example, we typically will not pay overdrafts if you fail to meet the eligibility requirements for this service or you attempt too many transactions or transactions that create too large of an overdraft. Call us at 1-833-954-0799 or log in to your Online Account Center for additional terms and conditions that apply, including initial and ongoing eligibility requirements for the service. <b>This service is expensive, so we encourage you to research alternatives before enrolling.</b> Once enrolled, you may opt-out at any time; however, you are responsible to repay any overdrawn amounts on your account even if you opt-out of the service.`
    },
    sections: [
      'activation',
      'anytime-alerts',
      'anytime-alerts-upgrade',
      'atm-finder',
      'bank-transfers',
      'card',
      'change-password',
      'change-username',
      'checks',
      'check-deposit',
      'close-account',
      'connected-banks',
      'dashboard',
      'digital-wallet',
      'direct-deposit',
      'direct-deposit-form',
      'direct-deposit-mobile-panel',
      'disclosure-dictionary',
      'dynamic-faq',
      'echecks',
      'feedback',
      'feeplan',
      'file-dispute',
      'fraud-detection',
      'handoff',
      'interstitials',
      'layout',
      'locations',
      'manage-gpr',
      'me-to-me-transfer',
      'mobile-check-load',
      'money-gram',
      'move-money',
      'offers',
      'overdraft',
      'post-install-multi-screen-acquisition-flow',
      'refer-a-friend',
      'savings',
      'secure-inbox',
      'secure-upload',
      'spend-money',
      'spending-tracker',
      'survey',
      'post-handoff-to-activate-register'
    ]
  }
};

export default variant;
